import {MatDialogConfig} from '@angular/material/dialog';
import {QueryFilterDialogType} from './query-filter-dialog.type';
import {TorchQueryFilter} from '../../../../@backend/modules/@filters/torch-query-filter.model';

export interface QueryFilterDialogData {
  type: QueryFilterDialogType;
  title: string;
  filter?: TorchQueryFilter;
  entity?: string;
  [key: string]: any;
}

export class QueryFilterDialogConfig extends MatDialogConfig {
  panelClass = 'query-filter-dialog';
  data: QueryFilterDialogData = {
    type: QueryFilterDialogType.MANAGE_FILTERS,
    title: 'Manage Your Filters'
  };

  /**
   * Create a config object
   * @param type - Query Filter Dialog type
   * @param filter - Optional TorchQueryFilter object
   * @param entity - Optional entity parameter
   */
  static create(type: QueryFilterDialogType, filter: TorchQueryFilter | null = null, entity: string | null = null) {
    const config = new QueryFilterDialogConfig();

    config.data.type = type;
    config.data.filter = filter;
    config.data.entity = entity;

    switch (type) {
      case QueryFilterDialogType.SAVE_NEW:
        config.data.title = 'Save New Filter';
        break;
      case QueryFilterDialogType.EDIT_EXISTING:
        if (!!filter && filter.displayName) {
          config.data.title = `Editing ${filter.displayName}`;
        } else {
          config.data.title = 'Editing Filter';
        }
        break;
      case QueryFilterDialogType.PICK_FILTER:
        config.data.title = 'Pick a Filter';
        break;
      default:
        config.data.title = 'Manage Your Filters';
        break;
    }

    return config;
  }
}
